module.exports = __webpack_public_path__ + "media/images/products/wedding/img-feature-accident-793b41e2b1e2cb652298a8786d5f664d.png";